import type { DataSourceProvider } from './data-source-provider';
import type { ADFReference } from './types';

export class NodeMutationObserver {
	private dataSourceProvider: DataSourceProvider;

	constructor(dataSourceProvider: DataSourceProvider) {
		this.dataSourceProvider = dataSourceProvider;
	}

	emit(id: string, adfReference: ADFReference): void {
		this.dataSourceProvider.createOrUpdate(id, adfReference);
	}
}
